import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_activity_highlight_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    activity_guid: fromDatatype.GuidDataFieldInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    is_recurring: boolean;
    rrule: fromDatatype.VarcharDatatypeInterface;
    display_order: fromDatatype.IntegerDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_activity_highlight_RowClass implements bl_cms_activity_highlight_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    activity_guid: fromDatatype.GuidDataFieldInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    is_recurring: boolean;
    rrule: fromDatatype.VarcharDatatypeInterface;
    display_order: fromDatatype.IntegerDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
